import stars from '../../assets/images/5-stars.png';

function Standards() {
  return (
    <div className="about__standards-container background__gradient">
      <div className="about__standards-wrapper column">
        <div className="about__standards-title">
          <h1>건강과 안전의 5성급 기준 유지</h1>
        </div>
        <div className="about__standards-content column">
          <div className="about__standards-row row">
            <div className="about__standards-item column">
              <div className="standards__item-stars">
                <img src={stars} alt="5-stars"/>
              </div>
              <div className="standards__item-text">
                <p>모든 재료와 포장 및 완제품까지 제조 과정의 추적이 가능합니다.</p>
              </div>
            </div>
            <div className="about__standards-item column">
              <div className="standards__item-stars">
                <img src={stars} alt="5-stars"/>
              </div>
              <div className="standards__item-text">
                <p>식품 안전과 품질 문제에 대한 통제를 위한 '식품 위해요소 중점 관리기준(HACCP)'을 따르고 있습니다.</p>
              </div>
            </div>
            <div className="about__standards-item column">
              <div className="standards__item-stars">
                <img src={stars} alt="5-stars"/>
              </div>
              <div className="standards__item-text">
                <p>모든 기존/신규 공급 업체에 대한 엄격한 승인 절차를 갖추고 있습니다.</p>
              </div>
            </div>
          </div>
          <div className="about__standards-row row">
            <div className="about__standards-item column">
              <div className="standards__item-stars">
                <img src={stars} alt="5-stars"/>
              </div>
              <div className="standards__item-text">
                <p>이물질 탐지를 통해 제조성분 외 이물질들이 들어가지 않게 하고 있습니다.</p>
              </div>
            </div>
            <div className="about__standards-item column">
              <div className="standards__item-stars">
                <img src={stars} alt="5-stars"/>
              </div>
              <div className="standards__item-text">
                <p>전 제품을 대상으로 정기적인 사내 및 공인된 연구실의 테스트를 실시합니다.</p>
              </div>
            </div>
            <div className="about__standards-item column">
              <div className="standards__item-stars">
                <img src={stars} alt="5-stars"/>
              </div>
              <div className="standards__item-text">
                <p>온도와 공기질이 조절되는 전용 구역에서 매 시간 품질 관리 검사를 시행하여 제품을 가공하고 포장하도록 시행하고 있습니다.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )  
}

export default Standards;
